import React, { useState, useEffect } from 'react';
import Navbar from './Navbar';
import Sidebar from './Sidebar';
import './css/Lab.css';
import './css/DetailsResultsAnal.css';
import labService from './labService';
import authService from '../auth/authService';
import { useParams, useNavigate } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTrashCan, faX } from '@fortawesome/free-solid-svg-icons';



const DetailsResultsAnal = ({ isCollapsed, toggleSidebar }) => {
  const { pk } = useParams(); // Extract pk from route parameters
  const [currentUser, setCurrentUser] = useState(null);
  const [analDetails, setAnalDetails] = useState(null);
  const [selectedPredictionIdx, setSelectedPredictionIdx] = useState(0);
  const [imageData, setImageData] = useState(null);
  const [imageList, setImageList] = useState(null);
  const [leveragePlot, setLeveragePlot] = useState(null);
  const [error, setError] = useState(null);
  const navigate = useNavigate();
  const [showModal, setShowModal] = useState(false);
  const [isConfirmed, setIsConfirmed] = useState(false);
  const [isDownloading, setIsDownloading] = useState(false);


    const handleGoBack = () => {
        navigate(-1); // This goes back one step in history
      };

    const goToLab = () => {
        navigate('/laboratory');
    };

  const openModal = () => setShowModal(true);
  const closeModal = () => {
    setShowModal(false);
    setIsConfirmed(false); // Reset confirmation checkbox
  };

  const handleDelete = () => {
    if (currentUser && pk && isConfirmed) {
      labService.deleteAnalysis(pk, currentUser.access)
        .then(() => {
          navigate('/laboratory/');
        })
        .catch(error => console.error(error))
        .finally(() => closeModal());
    }
  };

  useEffect(() => {
    const user = authService.getCurrentUser();
    setCurrentUser(user);
  }, []);

  useEffect(() => {
    if (currentUser && pk) {
      labService.getAnalysisDetail(pk, currentUser.access)
        .then(response => setAnalDetails(response.data))
        .catch(error => console.error(error));
    }
  }, [currentUser, pk]);

    useEffect(() => {
        const token = JSON.parse(localStorage.getItem('user'))?.access;
        if (!analDetails || !token) return;
    
        const allSmiles = analDetails.predictions
            ?.flatMap(prediction => prediction.similarities?.map(sim => sim.id) || [])
            ?.filter(Boolean); // Remove nulls/undefined just in case
    
        // const uniqueSmiles = [...new Set(allSmiles)]; // Remove duplicates
        
        
        const fetchImagesList = async () => {
            try {
                const response = await labService.getSmilesImageList(allSmiles, token);
                setImageList(response.data.images);
                // console.log(response.data.images)
            } catch (error) {
                console.error('Error fetching images:', error);
                setError('Failed to fetch images. Please try again.');
            }
        };
    
        fetchImagesList();
    
    }, [analDetails]);
    

  useEffect(() => {
    const token = JSON.parse(localStorage.getItem('user'))?.access;

    if (!token) {
      setError("You must be logged in to view this page.");
      return;
    }

    const fetchImageSmiles = async () => {
      try {
        const response = await labService.getSmilesImage2(pk, token);
        setImageData(response.data.image_data);
      } catch (error) {
        console.error('Error fetching image:', error);
        setError('Failed to fetch image. Please try again.');
      }
    };

    const fetchLeveragePlot = async () => {
      try {
        const response = await labService.getLeveragePlot(pk, token);
        setLeveragePlot(response.data.plots);
      } catch (error) {
        console.error('Error fetching images:', error);
        setError('Failed to fetch images. Please try again.');
      }
    };

    fetchImageSmiles();
    fetchLeveragePlot()

  }, [pk]);

  const handlePredictionClick = (idx) => {
    if (idx === selectedPredictionIdx) {
      return; // Do nothing if the current item is clicked
    }
    setSelectedPredictionIdx(idx); // Set the selected prediction index
  };

    // Helper function for formatting values
    const formatValue = (prediction, fix_decimal=6) => {
        if (prediction.method === 'regression') {
          const value = parseFloat(prediction.predicted_value);
          return Math.abs(value) < 1e-3 ? value.toExponential(2) : value.toFixed(fix_decimal);
        } else if (prediction.method === 'classification') {
            
            let classIndex;
            try {
              classIndex = parseInt(prediction.predicted_value);
              
              // Check if the result is actually a number
              if (isNaN(classIndex)) {
                throw new Error("Parsed value is not a number");
              }
            } catch (error) {
            //   console.error("Error parsing prediction value:", error);
              // Set a default value or handle the error as needed
              return prediction.predicted_value
            }
          
          let classNotations = prediction.class_notations;
      
          if (typeof classNotations === 'string') {
            try {
              // Replace single quotes with double quotes and parse
              const normalized = classNotations.replace(/'/g, '"');
              classNotations = JSON.parse(normalized);
            } catch (error) {
              console.error('Invalid class_notations format:', error);
              return 'Unknown';
            }
          }
      
          if (classNotations && typeof classNotations === 'object') {
            return classNotations[classIndex.toString()] || 'Unknown';
          }
      
          return 'Unknown';
        }
        return 'N/A';
    };
    const handleDownloadZip = async () => {
        if (currentUser && pk) {
        setIsDownloading(true);
        try {
            const response = await labService.downloadReportsZip(pk, currentUser.access);
            const file = new Blob([response.data], { type: 'application/zip' });
            const fileURL = URL.createObjectURL(file);
            const link = document.createElement('a');
            link.href = fileURL;
            link.setAttribute('download', `analysis_${pk}_reports.zip`);
            document.body.appendChild(link);
            link.click();

            link.parentNode.removeChild(link);
            URL.revokeObjectURL(fileURL);
        } catch (error) {
            console.error('Error downloading the reports:', error);
            setError('Failed to download ZIP reports. Please try again.');
        } finally {
            setIsDownloading(false);
        }
        }
    };
    
    
    return (
        <div className='lab-container'>
            <Navbar />
            <div className='lab-side-content'>
                <Sidebar active_n={1} isCollapsed={isCollapsed} toggleSidebar={toggleSidebar} />
                <div className='new-pred-container'>
                    <div className='np-tabs'>
                        <div className='x'>
                            <button onClick={goToLab} className='x-but'>
                                <FontAwesomeIcon className='icon-x' icon={faX} />
                            </button>
                        </div>
                        <div className='np-steps comp-tab-1'>
                            <p className='p-step'>STEP 1</p>
                            <p>Select Model</p>
                        </div>
                        <div className='np-steps comp-tab-2'>
                            <p className='p-step'>STEP 2</p>
                            <p>Define Compound</p>
                        </div>
                        <div className='np-steps comp-tab-3'>
                            <p className='p-step'>STEP 3</p>
                            <p>Summary</p>
                        </div>
                        <div className='np-steps comp-tab-4'>
                            <p className='p-step'>STEP 4</p>
                            <p>Results</p>
                        </div>
                    </div>
                    <div className='np-content-det'>
                        {showModal && (
                        <div className="modal">
                            <div className="modal-content">
                                <div className="modal-header">
                                    <div className="trash-icon">
                                        <FontAwesomeIcon icon={faTrashCan} size="2x" />
                                    </div>
                                    <button className="close-button" onClick={closeModal}>
                                        ×
                                    </button>
                                </div>
                                <div className='modal-con'>
                                    <p className="p-delete">
                                        This action will delete all data regarding your prediction.
                                    <br/>
                                        Your tokens <strong>will not be refunded</strong> in this case.
                                    <br/>
                                        Please confirm by checking the box below.
                                    </p>

                                    <label className='p-delete confirm-txt'>
                                        <input
                                            type="checkbox"
                                            className='delete-check'
                                            checked={isConfirmed}
                                            onChange={(e) => setIsConfirmed(e.target.checked)}
                                        />
                                        I confirm that I want to delete this prediction result.
                                    </label>
                                    <div className="modal-buttons">
                                        <button className={`confirm-btn ${isConfirmed ? '' : 'disabled-btn'}`} onClick={handleDelete} disabled={!isConfirmed}>
                                            Submit
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                        )}

                            
                    


                        {/* Render analysis details if available */}
                        {analDetails ? (
                        <div className='details-main-content'>
                            <div className='anal-name-row det-chui'>
                                <p className='main-text anal-name-label det-18'>Analysis name</p>
                                <div className='anal-div-value'>
                                    {analDetails ? <p>{analDetails.name}</p> : <p>Loading...</p>}
                                </div>
                            </div>
                            <div className='endp-btns'>
                                <p className='green-head'>Model Selection</p>
                                <div className='btns-model-names'>
                                    {analDetails.predictions
                                    .filter(prediction => prediction.status === 'Done')
                                    .map((prediction, idx) => (
                                        <button
                                            onClick={() => handlePredictionClick(idx)}
                                            className={`prediction-name-btn ${selectedPredictionIdx === idx ? 'selected-btn' : ''}`}
                                        >
                                            {prediction.model_name}
                                        </button>
                                    ))}
                                </div>
                            </div>
                            <div className='details-content'>
                                
                                <div className='left-details'>
                                    <div className='left-details-up'>
                                        
                                        <p className='green-head'>Your compound</p>
                                        <div className='spec-det-div smiles-center-div'>
                                            <div>
                                                {imageData ? (
                                                    <img className='smiles-img-res' src={`${imageData}`} alt="Analysis" />
                                                ) : (
                                                    <img src="https://via.placeholder.com/300" alt="Compound structure" />
                                                )}
                                            </div>
                                        </div>
                                        
                                    </div>
                                </div>

                                <div className='mid-details'>
                                    {analDetails.predictions
                                                    .filter(prediction => prediction.status === 'Done')
                                                    .map((prediction, idx) => (
                                    <div>
                                        {selectedPredictionIdx === idx && (
                                            <div className='prediction-details'>
                                                {Object.entries(prediction.calc_param).map(([key, value], idx) => (
                                                <>
                                                <p className='green-head'>Endpoint details</p>
                                                
                                                <div className='mid-det-div'>
                                                    <p className='grey-up'>Dependent variable</p>
                                                    <p className='deta-val'>{key} {value ? `${value}` : ''}</p>
                                                </div>

                                                <p className='green-head'>Prediction details</p>
                                                <div className='mid-det-div'>
                                                    <p className='grey-up'>
                                                        Predicted Value
                                                    </p>
                                                    <p className='deta-val pred-value'
                                                    // style={{ color: formatValue(prediction) === "No inhibition" || formatValue(prediction) === "Not disruptive" || formatValue(prediction) === 'Inactive' ? '#72ba6e' : '#ac361d' }}>
                                                    >
                                                    {formatValue(prediction)}
                                                    </p>
                                                    
                                                </div>
                                                {!prediction.domain_check ? (
                                                        <div className='domain-check-warning'>
                                                            <p>Prediction is out of domain</p>
                                                            <p>Token for this prediction has been refunded. </p>
                                                            
                                                        </div>
                                                    ) : ( <></>
                                                    )}

                                                </>
                                                ))}
                                                    
                                                
                                            </div>
                                        )}
                                    </div>
                                    ))}
                                </div> 

                                <div className='right-details'>
                                    <div className='right-details-up'>
                                        <p className='green-head'>Descriptors values</p>
                                        <div className='pred-deta-div spec-det-div descriptors-values-div'>
                                            {analDetails.predictions
                                                .filter(prediction => prediction.status === 'Done')
                                                .map((prediction, idx) => (
                                                <div key={idx}>
                                                    {selectedPredictionIdx === idx && (
                                                        <div className='prediction-details'>
                                                            <div className='descriptors-wrapper'>
                                                                
                                                                {/* 1. The Header Row */}
                                                                <div 
                                                                    className='descriptors-header' 
                                                                    style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '10px', marginBottom: '8px' }}
                                                                >
                                                                    <p className='grey-up' style={{ margin: 0, fontWeight: 'bold', textAlign: 'left' }}>Descriptor</p>
                                                                    {/* Aligned the header to the right */}
                                                                    <p className='grey-up' style={{ margin: 0, fontWeight: 'bold', textAlign: 'right' }}>Value</p>
                                                                </div>

                                                                {/* 2. The Data Rows */}
                                                                {Object.entries(prediction.descriptors_values).map(([key, value]) => (
                                                                    <div 
                                                                        className='desc-list-row txt-greyish' 
                                                                        key={key} 
                                                                        style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '10px' }}
                                                                    >
                                                                        <p className='desc-kv' style={{ margin: '4px 0', textAlign: 'left' }}>
                                                                            {key}
                                                                        </p>
                                                                        {/* Aligned the actual values to the right */}
                                                                        <p className='desc-kv' style={{ margin: '4px 0', textAlign: 'right' }}>
                                                                            {typeof value === 'number' 
                                                                                ? (Math.abs(value) < 0.0001 && value !== 0 
                                                                                    ? value.toExponential(4) 
                                                                                    : (value.toString().includes('.') && value.toString().split('.')[1].length > 4 
                                                                                        ? value.toFixed(4) 
                                                                                        : value)) 
                                                                                : value}
                                                                        </p>
                                                                    </div>
                                                                ))}

                                                            </div>
                                                        </div>
                                                    )}
                                                </div>
                                            ))}
                                        </div>
                                    </div>
                                    
                                </div>
                            
                            </div>
                        </div>
                        ) : (
                            <p>Loading analysis details...</p>
                        )}

                        {/* NEW: Bottom Action Buttons */}
                        <div className="bottom-action-buttons">
                            <div className="left-actions">
                                <button className="go-back-btn-sum" onClick={() => {handleGoBack()}}>
                                    Back
                                </button>
                            </div>
                            <div className="right-actions">
                                <button className="download-btn" onClick={() => {handleDownloadZip()}}>
                                    Download report
                                </button>
                                {/* Assuming you want this to open your existing modal */}
                                <button className="del-pre-btn" onClick={() => setShowModal(true)}>
                                    Delete prediction
                                </button>
                            </div>
                        </div>
                    
                    
                    </div>
                
                </div>
            </div>
        </div>
    );
};

export default DetailsResultsAnal;
